export const features = [
  {
    id: 1,
    title: 'Mind Training',
    description: 'Short exercises for stress, anxiety, confidence, and focus',
    icon: 'ri-brain-line',
  },
  {
    id: 2,
    title: 'Simple Routines',
    description: 'Morning focus, stress reset, wind-down, and more',
    icon: 'ri-refresh-line',
  },
  {
    id: 3,
    title: 'Nootropic Reviews',
    description: 'Honest, researched reviews with safety info',
    icon: 'ri-capsule-line',
  },
  {
    id: 4,
    title: 'Productivity Tools',
    description: 'Habit trackers, goal setting, and weekly challenges',
    icon: 'ri-bar-chart-line',
  },
  {
    id: 5,
    title: 'Progress Tracking',
    description: 'Track mood, focus, energy, sleep, and productivity',
    icon: 'ri-line-chart-line',
  },
  {
    id: 6,
    title: 'Safe & Responsible',
    description: 'Educational only — clear disclaimers, no medical advice',
    icon: 'ri-shield-check-line',
  },
];

export const testimonials = [
  {
    id: 1,
    quote: 'ClearMind helped me build a morning routine that actually sticks. My focus has never been better.',
    name: 'Sarah M.',
    rating: 5,
  },
  {
    id: 2,
    quote: 'The nootropic reviews are so well-researched. I finally found what works for me without the guesswork.',
    name: 'James K.',
    rating: 5,
  },
  {
    id: 3,
    quote: 'The mind training exercises are simple but powerful. The stress reset routine is now a daily habit.',
    name: 'Emily R.',
    rating: 5,
  },
];